<template>
  <text-block
    v-if="content.type === 'text'"
    :content="content.content"
    :footnote="content.footnote"
    :quote="content.quote"
    :isTitle="content.isTitle"
  />
  <image-block v-else :content="content.content" />
</template>

<script>
import TextBlock from "./TextBlock.vue";
import ImageBlock from "./ImageBlock.vue";

export default {
  name: "block",
  components: {
    TextBlock,
    ImageBlock
  },
  props: {
    content: Object,
    validator: function(value) {
      return value.type === "img" || value.type === "text";
    }
  }
};
</script>

<style>
</style>
